module.exports = __webpack_public_path__ + "media/images/bottom-border-2001e4632fcd5f7efd89efdbcb534cbc.svg";